import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import PagesFaqs from "../pages/Utility/pages-faqs"
import Bag from "../pages/Bag"
import BagForm from "../pages/Bag/BagForm"
import Sale from "../pages/Sale"
import Report from "../pages/Report"
import StoreManagement from "../pages/StoreManagement"
import UserManagement from "../pages/UserManagement"
import Review from "../pages/Review"
import UserForm from "../pages/UserManagement/userForm"
import Schedule from "../pages/Schedule"
import CalendarPage from "../pages/Calendar/index"
import Pages404 from "../pages/Utility/pages-404"
import ChangePassword from "../pages/Authentication/ChangePassword"
import PartnerSignupPage from "../pages/PartnerSignup/PartnerSignupPage"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard />, requiredRoles:["admin", "manager"] },
  { path: "/bags", component: <Bag />, requiredRoles:["admin", "manager", "seller"] },
  { path: "/bags/add", component: <BagForm />, requiredRoles:["admin", "manager"], requiresPublishing: true },
  { path: "/bags/edit/:id", component: <BagForm />, requiredRoles:["admin", "manager"] },
  { path: "/users/add", component: <UserForm />, requiredRoles:["admin"] },
  { path: "/calendar", component: <CalendarPage />, requiredRoles:["admin", "manager", "seller"], requiresPublishing: true },
  { path: "/schedule", component: <Schedule />, requiredRoles:["admin", "manager", "seller"], requiresPublishing: true },
  { path: "/sales", component: <Sale />, requiredRoles:["admin", "manager", "seller"] },
  { path: "/reports-analytics", component: <Report />, requiredRoles:["admin", "manager"] },
  { path: "/store-settings", component: <StoreManagement />, requiredRoles:["admin", "manager"] },
  { path: "/users-access", component: <UserManagement />, requiredRoles:["admin", "manager"] },
  { path: "feedback-reviews", component: <Review />, requiredRoles:["admin", "manager"] },
  { path: "/faq", component: <PagesFaqs /> },
  { path: "/change-password", component: <ChangePassword />, requiredRoles:["admin", "manager", "seller"] },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/partner/signup", component: <PartnerSignupPage /> },
  { path: "/404", component: <Pages404 /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
];

export { authProtectedRoutes, publicRoutes };
